import React from "react";
import StringField from "./StringField";
import ObjectField from "./ObjectField";

export default function ListField({ value, onChange, path, onUploadAsset }) {
  const list = Array.isArray(value) ? value : [];
  const updateAt = (i, v) => {
    const next = [...list];
    next[i] = v;
    onChange(next);
  };
  const removeAt = (i) => onChange(list.filter((_, idx) => idx !== i));
  const addItem = () => {
    const template = list.length > 0 && typeof list[0] === "object" && list[0] !== null
      ? Object.fromEntries(Object.keys(list[0]).map((k) => [k, ""]))
      : "";
    onChange([...list, template]);
  };
  return (
    <div className="border border-white/10 p-4 space-y-4">
      {list.map((item, i) => (
        <ListItem
          key={i}
          item={item}
          i={i}
          path={path}
          updateAt={updateAt}
          removeAt={removeAt}
          onUploadAsset={onUploadAsset}
        />
      ))}
      <button
        onClick={addItem}
        data-testid={`add-${path.join(".")}`}
        className="font-mono text-[10px] tracking-[0.25em] uppercase border border-white/20 px-3 py-2 hover:bg-white hover:text-black transition-all"
      >
        + Add item
      </button>
    </div>
  );
}

function ListItem({ item, i, path, updateAt, removeAt, onUploadAsset }) {
  const subPath = [...path, String(i)];
  const isObj = typeof item === "object" && item !== null;
  return (
    <div className="border-l-2 border-white/15 pl-4" data-testid={`list-item-${path.join(".")}-${i}`}>
      <div className="flex items-center justify-between mb-2">
        <span className="overline">Item {i + 1}</span>
        <button
          onClick={() => removeAt(i)}
          className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#c01515] hover:underline"
          data-testid={`remove-${path.join(".")}-${i}`}
        >
          Remove
        </button>
      </div>
      {isObj
        ? React.createElement(ObjectField, {
            value: item,
            onChange: (v) => updateAt(i, v),
            path: subPath,
            onUploadAsset,
          })
        : <StringField value={item} onChange={(v) => updateAt(i, v)} path={subPath} />}
    </div>
  );
}
